type Props = {
    url: string;
};

export const OnboardingForm: React.FC<Props> = ({ url }) => {
    return <iframe className="w-full h-full min-h-screen" src={url}></iframe>;
};
